/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

gbc.constants.style = {
  /**
   * The mapping between 4st value and HEX value
   */
  colorMap: {
    green: "#008000",
    darkOlive: "#505000",
    lightTeal: "#33cccc",
    lightOrange: "#ffcc00",
    lightMagenta: "#ffc0ff",
    darkTeal: "#005050",
    lightRed: "#ff8080",
    darkYellow: "#aaaa00",
    lightYellow: "#ffffe0",
    window: "Window",
    windowText: "WindowText",
    buttonFace: "ButtonFace",
    buttonText: "ButtonText",
    highLight: "Highlight",
    highLightText: "HighlightText",
    infoBackground: "InfoBackground",
    infoText: "InfoText",
    grayText: "GrayText",
    appWorkSpace: "AppWorkspace",
    background: "Background",
    systemalternatebackground: "#eeeeee"
  },

  /**
   * The mapping between 4st fontWeight value and CSS
   */
  fontWeightMap: {
    light: "100",
    normal: "400",
    "demi-bold": "600",
    bold: "700",
    black: "900"
  }
};
